var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.334C14.5923 18.334 18.334 14.5923 18.334 10.0007C18.334 5.40898 14.5923 1.66732 10.0007 1.66732C5.40898 1.66732 1.66732 5.40898 1.66732 10.0007C1.66732 14.5923 5.40898 18.334 10.0007 18.334ZM10.6257 13.334C10.6257 13.6757 10.3423 13.959 10.0007 13.959C9.65898 13.959 9.37565 13.6757 9.37565 13.334L9.37565 9.16732C9.37565 8.82565 9.65898 8.54232 10.0007 8.54232C10.3423 8.54232 10.6257 8.82565 10.6257 9.16732V13.334ZM9.23398 6.35065C9.27565 6.24232 9.33398 6.15899 9.40898 6.07565C9.49232 6.00065 9.58398 5.94232 9.68398 5.90065C9.78398 5.85898 9.89232 5.83398 10.0007 5.83398C10.109 5.83398 10.2173 5.85898 10.3173 5.90065C10.4173 5.94232 10.509 6.00065 10.5923 6.07565C10.6673 6.15899 10.7257 6.24232 10.7673 6.35065C10.809 6.45065 10.834 6.55898 10.834 6.66732C10.834 6.77565 10.809 6.88398 10.7673 6.98398C10.7257 7.08398 10.6673 7.17565 10.5923 7.25898C10.509 7.33398 10.4173 7.39232 10.3173 7.43398C10.1173 7.51732 9.88398 7.51732 9.68398 7.43398C9.58398 7.39232 9.49232 7.33398 9.40898 7.25898C9.33398 7.17565 9.27565 7.08398 9.23398 6.98398C9.19232 6.88398 9.16732 6.77565 9.16732 6.66732C9.16732 6.55898 9.19232 6.45065 9.23398 6.35065Z",
    fill: "#FFB25B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.3df6ebe344bd0951ccd0ace831998672.svg";
export { ForwardRef as ReactComponent };